import React from 'react';
import { Box } from '@mui/material';

import { v2Colors } from '../../design/theme';

/** Custom maroon radio circle for checkout selection cards. */
export default function CheckoutRadioIndicator({ selected }) {
  return (
    <Box
      aria-hidden
      sx={{
        width: 20,
        height: 20,
        borderRadius: '50%',
        border: '2px solid',
        borderColor: selected ? v2Colors.canvas : v2Colors.primary,
        bgcolor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        mt: 0.25,
      }}
    >
      {selected ? (
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            bgcolor: v2Colors.canvas,
          }}
        />
      ) : null}
    </Box>
  );
}
